import React from "react";
import { Route, Redirect, RouteProps, useLocation } from "react-router-dom";
import { useAuthenticatedUserContext } from "../../features/Auth/UserProvider";

/**
 * ProtectedRoute
 *
 * This component should mirror <Route /> in function but verifies the user
 * has a valid OAuth token and in case they don't, redirect them to /login
 */
export const ProtectedRoute: React.FC<RouteProps> = ({
  path,
  render,
  component,
  children,
  ...rest
}) => {
  const { pathname: currentLocation } = useLocation();
  const { user, loading } = useAuthenticatedUserContext();

  /**
   * NOTE: To ensure compatibility/the same API as the native <Route> tag
   *       need to support rendering:
   *        - <Route path="/"><MyComponent></Route>
   *        - <Route path="/" children={(match) => <MyComponent />} />
   *        - <Route path="/" render={(match) => <MyComponent />} />
   *        - <Route path="/" component={MyComponent} />
   */

  return (
    <Route
      path={path}
      {...rest}
      render={(match) => {
        return user
          ? // If authenticated
            children
            ? typeof children === "function"
              ? // 1. children === function => execute children func with props
                // @ts-ignore
                children(match)
              : // 2. children !== function => render children
                children
            : // 3. component handling
            component
            ? React.createElement(component, match)
            : // 4. render handling
            render
            ? render(match)
            : null
          : // If not authenticated redirect
            !loading && (
              <Redirect
                to={{
                  pathname: "/login",
                  state: {
                    from: currentLocation,
                  },
                }}
              />
            );
      }}
    />
  );
};
